import { StaffListUsers } from '@features/staffMember/components/users/StaffListUsers'
import { createFileRoute } from '@tanstack/react-router'

const ListUsersRoute = () => <StaffListUsers />

export const Route = createFileRoute('/_auth/staff/u/')({
  component: ListUsersRoute,
})
